"use client";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import QuotationForm from "../forms/quotation-form";

const SectionQuotation = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  return (
    <section className="relative py-16 after:absolute bg-cover bg-fixed after:inset-0 after:bg-stats/80 lg:py-28" style={{ backgroundImage: 'url(/quotation_form_bg.webp)' }}>
      <div className="container">
        {isMounted ? (
          <motion.div
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
              delay: 0.5,
            }}
          >
            <QuotationForm />
          </motion.div>
        ) : (
          <div>
            <QuotationForm />
          </div>
        )}
      </div>
    </section>
  );
};

export default SectionQuotation;